package es.subastia.domain.model

data class AuctionDomainModel(
    val auctionId: String,
    val title: String,
    val description: String? = null,
    val currentPrice: Double? = null,
    val basePrice: Double? = null,
    val dates: AuctionDatesDomainModel,
    val authority: AuctionAuthorityDomainModel? = null,
    val location: String? = null,
    val category: AuctionTypeDomainModel? = null,
    val procedureType: AuctionProcedureType? = null,
    val offersCount: Int = 0,
    val accountExpediente: String? = null,
    val aiSummary: String? = null,
    val appraisalValue: Double,
    val auctionValue: Double,
    val address: String?,
    val code: String? = null,
    val email: String? = null,
    val fax: String? = null,
    val model: String? = null,
    val phone: String? = null,
    val bidStep: Double,
    val boeAnnouncement: String? = null,
    val boeId: String? = null,
    val catastralRef: String? = null,
    val city: String? = null,
    val claimedAmount: Double,
    val depositAmount: Double,
    val hasLots: Boolean = false,
    val isGoodOpportunity: Boolean = false,
    val lotId: Int? = null,
    val minBid: Double? = null,
    val portalUrl: String,
    val province: ProvinceDomainModel? = null,
    val status: String? = null,
    val updatedAt: String? = null,
    val lots: List<LotDomainModel> = emptyList() // Associated Assets/Lots
)

data class AuctionDatesDomainModel(
    val startDate: String?,
    val endDate: String?
)

data class AuctionAuthorityDomainModel(
    val name: String? = null,
    val email: String? = null,
    val phone: String? = null
)
